import Box from '@mui/material/Box'

export const CvFlexBox = props => (
  <Box display="flex" alignItems="center" justifyContent="center" {...props}>
    {props.children}
  </Box>
)
